import { createAsyncThunk } from '@reduxjs/toolkit';
import { getEppDampers } from 'application/components/api/EppDamper';
import { selectComponentState } from 'projectRedux/store';

export const fetchAsyncEppDampers = createAsyncThunk(
  'components/fetchAsyncEppDampers',
  async (data: {}, thunkAPI) => {
    const response = await getEppDampers();
    return response;
  },
  {
    condition(arg, thunkAPI) {
      return selectComponentState(thunkAPI.getState()).eppDampers.loading === 'init';
    },
  }
);
